var daram = (function() {
	var slide = function(){
      
//       $("#mainContents .conBox02 .mask1 .slider").on('init',function(){
//         $(".slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
//         $(".slick-active").next().removeClass('prevdiv').addClass('nextdiv');
//     });
      
		var main_tech1 = $("#mainContents .conBox02 .mask1 .slider").slick({
			dots:false,
			slidesToShow:1,
			slidesToScroll:1,
			focusOnSelect:true,
			variableWidth:true,
			prevArrow:"#mainContents .conBox02 .btnPrev",
			nextArrow:"#mainContents .conBox02 .btnNext",
			asNavFor:"#mainContents .conBox02 .mask2 .slider",
          
          
            draggable:false,
            infinite:true,
            autoplay: false, 
            speed:1000,
            easing:'linear',
            variableWidth:true,
          
			responsive: [{
				breakpoint: 1025,
				settings: {
					variableWidth:false,
				}
			}]
		});
      
      
//           $("#mainContents .conBox02 .mask1 .slick-active").addClass("on");
          main_tech1.on("afterChange", function(event, slick, currentSlide){
              //console.log(currentSlide+1);
//               $("#mainContents .conBox02 .mask1 .slick-slide").removeClass("on");
//               $("#mainContents .conBox02 .mask1 .slick-active").addClass("on");
            
//               for (var i = 0; i < slick.$slides.length; i++)
//               {
//                 var $slide = $(slick.$slides[i]);
//                 if ($slide.hasClass('slick-current')) {
//                   // update DOM siblings
//                   $slide.prev().addClass('prevdiv');
//                   $slide.next().addClass('nextdiv');
//                   break;
//                 }
//               }
            
          });
		var main_tech2 = $("#mainContents .conBox02 .mask2 .slider").slick({
			dots:false,
			slidesToShow:1,
			slidesToScroll:1,
			focusOnSelect:true,
			fade:true,
			arrows:false,
			asNavFor:"#mainContents .conBox02 .mask1 .slider",
			//prevArrow:"#mainContents .conBox02 .btnPrev",
			//nextArrow:"#mainContents .conBox02 .btnNext",
		})
	}
	return {
		slide:slide,
	}
}());

$(function(){
  
	daram.slide();
  
})